var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InformList"},[_c('div',{staticClass:"item"},[_c('Inform',{attrs:{"msg":'待办',"types":2}})],1),_c('div',{staticClass:"item"},[_c('Inform',{attrs:{"msg":'预警',"types":3}})],1),_c('div',{staticClass:"item"},[_c('Inform',{attrs:{"msg":'消息',"types":1}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }